import { type Enum } from '@webapp/infrastructure/types/Enum'

// EFT and WIRE are legacy types the bank form does not offer; existing
// records (and public-API creations) can still carry them.
export const ExternalBankAccountTypes = {
  OTHER: 0,
  CHECK: 1,
  ACH: 2,
  EFT: 3,
  WIRE: 4,
} as const

export type ExternalBankAccountTypeEnum = Enum<typeof ExternalBankAccountTypes>
